import script from "./BrochureEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./BrochureEdit.vue?vue&type=script&setup=true&lang=js"

import "./BrochureEdit.vue?vue&type=style&index=0&id=3a8f8b34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a8f8b34"]])

export default __exports__